
export default  {
   API_KEY:  'AIzaSyAkjzNdK2Mf_O4z6iWHBrgu1ncwcyjyJtM',
   //PORTAL_APIURL: (process.env.NODE_ENV === "development") ? (process.env.USERDOMAIN === "WOLF2") ? 'localhost:9040' : 'http://sandbox.ioihan.com:9040/portal/1' : 'https://api.icare.cafe/portal/1'
   PORTAL_APIURL: (process.env.NODE_ENV === "development") ? 'http://localhost:9040/portal/1'  : 'https://api.icare.cafe/portal/1'
  //  PORTAL_APIURL: (process.env.NODE_ENV === "development") ? 'http://sandbox.ioihan.com:9040/portal/1'  : 'https://api.icare.cafe/portal/1'
}
